<template>
  <div>
    <my-table :title="title"
              :searchParams="searchParams"
              :tableData="tableData"
              @pageNumChange="pageNumChange"
              @search="search"
              @keyup.enter.native="keyup()">
      <div slot="table">
        <daily-push-table :tableData="tableData.list" @view="view" @del="del"></daily-push-table>
      </div>
    </my-table>
  </div>
</template>

<script>
  import DailyPushTable from "./DailyPushTable";
  import MyTable from "../../components/content/myTable/MyTable";
  import {getDailyPushBySearch,newVue,delByDailyPushId} from "../../network/dailyPush";

  export default {
    name: "dailyPushList",
    components: {DailyPushTable, MyTable},
    data(){
      return {
        title: "精选商品列表",
        //搜索条件
        searchParams:[
          {
            key:"date",
            value:"日期"
          },
          {
            key:"skuNo",
            value:"商品编号"
          },
        ],
        tableData:{},
        searchItems:{}
      }
    },
    created() {
      newVue.obj = this;
      this.common.HeaderLocationTwo.href = "/dailyPush/list";
      this.common.HeaderLocationTwo.name = "每日精选商品管理";
      this.common.HeaderLocationThree.name = "精选商品列表"
      getDailyPushBySearch().then(res => {
        this.tableData = res.data
      })
    },
    methods:{
      pageNumChange(pageNum){
        this.searchEasy(this.searchItems,pageNum);
      },
      search(searchItems){
        this.searchItems = searchItems;
        this.searchEasy(searchItems)
      },
      searchEasy(searchItems,pageNum){
        let date = null;
        let skuNo = null;
        for (let i = 0;i<searchItems.length;i++){
          if (searchItems[i].value === "date") {
            date = searchItems[i].input
          }else if (searchItems[i].value === "skuNo") {
            skuNo = searchItems[i].input
          }
        }
        getDailyPushBySearch(date,skuNo,pageNum).then(res => {
          this.tableData = res.data
        })
      },
      keyup(){
        this.searchEasy(this.searchItems);
      },
      view(id){
        this.$router.push("/pmsSkuInfo/data/"+id)
      },
      del(id){
        this.$confirm('此操作会将该商品从精选中删除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delByDailyPushId(id).then(res => {
              if (res.code == 200) {
                this.searchEasy(this.searchItems);
              }
            }
          )
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      }
    }
  }
</script>

<style scoped>

</style>
